export default __webpack_public_path__ + "static/media/juego5_inicio.4e0781f3.png";